import { render, staticRenderFns } from "./actStage.vue?vue&type=template&id=392de2d4&scoped=true&"
import script from "./actStage.vue?vue&type=script&lang=js&"
export * from "./actStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392de2d4",
  null
  
)

export default component.exports